import React, {FC} from 'react'
import { Grid } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'
import { LKButton } from 'loankeeper-common/components'

//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import FormElement from 'shared/newFormElements'

import { CalcDatePickerSectionProps } from 'src/features/LoanDetails/types.LoanDetails'

const RESERVE_CALC_FORM_NAME = 'loan-details-reservecalc'

const DatePickerSection: FC<CalcDatePickerSectionProps> = ({ handleSubmit, loading }) => (
  <form style={{ width: '100%' }} onSubmit={handleSubmit}>
    <GridContainer style={{ marginTop: 10 }}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={2} />

          <Grid.Column className="u-flex" width={12} textAlign="center">
            <FormElement type="date" name="EndDate" />
            {/*@ts-ignore */}
            <LKButton disabled={loading} alias="chip" size="medium" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </GridContainer>
  </form>
)

export default reduxForm({
  form: RESERVE_CALC_FORM_NAME,
  //@ts-ignore
})(DatePickerSection)
